import React, { useState, useEffect, useRef } from 'react';
import './AssistantDropdown.css';
import { matchesSearch } from '../utils/search';

const TalkliveInstanceDropdown = ({
  value,
  onChange,
  options = [],
  excludeValues = [],
  placeholder = 'Select instance...',
  loading = false,
  disabled = false,
}) => {
  const [filteredOptions, setFilteredOptions] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const dropdownRef = useRef(null);

  const selectableOptions = options.filter(
    (option) => option.value === value || !excludeValues.includes(option.value)
  );

  useEffect(() => {
    if (!searchTerm) {
      setFilteredOptions(selectableOptions);
    } else {
      setFilteredOptions(
        selectableOptions.filter(
          (option) =>
            matchesSearch(searchTerm, option.label, option.value, option.sublabel)
        )
      );
    }
  }, [searchTerm, options, excludeValues, value]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleSelect = (option) => {
    onChange(option.value);
    setIsOpen(false);
    setSearchTerm('');
  };

  const handleInputChange = (e) => {
    setSearchTerm(e.target.value);
    setIsOpen(true);
  };

  const handleInputClick = () => {
    if (!disabled) {
      setIsOpen(true);
    }
  };

  const getDisplayValue = () => {
    if (!value) return '';
    const selected = options.find((option) => option.value === value);
    return selected ? selected.label : value;
  };

  return (
    <div className="assistant-dropdown" ref={dropdownRef}>
      <input
        type="text"
        value={isOpen ? searchTerm : getDisplayValue()}
        onChange={handleInputChange}
        onClick={handleInputClick}
        placeholder={placeholder}
        className="assistant-dropdown-input"
        readOnly={!isOpen}
        disabled={disabled}
      />
      {isOpen && !disabled && (
        <div className="assistant-dropdown-menu">
          {loading ? (
            <div className="dropdown-loading">Loading instances...</div>
          ) : filteredOptions.length === 0 ? (
            <div className="dropdown-no-results">No instances found</div>
          ) : (
            filteredOptions.map((option) => (
              <div
                key={option.value}
                className="dropdown-option"
                onClick={() => handleSelect(option)}
              >
                <div className="assistant-name">{option.label}</div>
                {option.sublabel && (
                  <div className="assistant-id">{option.sublabel}</div>
                )}
              </div>
            ))
          )}
        </div>
      )}
    </div>
  );
};

export default TalkliveInstanceDropdown;
